import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gauge, Loader2, RefreshCw, Sliders } from "lucide-react";
import { operasyonHub } from "@/lib/api";

export default function DkKalibrasyonPage() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            setData(await operasyonHub.dkKalibrasyon());
        } catch {
            setData(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    return (
        <div className="max-w-screen-2xl mx-auto space-y-6 pb-16 px-4">
            <header className="flex flex-wrap items-center justify-between gap-4">
                <div>
                    <p className="text-[10px] uppercase tracking-[0.2em] text-[#D4AF37]">Akıl Öğrenme</p>
                    <h1 className="font-display text-3xl text-white mt-1">Değer Kaybı Kalibrasyon</h1>
                    <p className="text-sm text-slate-500 mt-1 max-w-xl">
                        Marka/model bazlı öğrenme çarpanları — tahmin kalitesi zamanla artar. Çarpan 0.85–1.15
                        aralığında tutulur.
                    </p>
                </div>
                <button
                    type="button"
                    onClick={load}
                    disabled={loading}
                    className="h-10 px-4 rounded-xl bg-[#D4AF37] text-slate-900 text-sm font-bold inline-flex items-center gap-2"
                >
                    <RefreshCw className={`h-4 w-4 ${loading ? "animate-spin" : ""}`} />
                    Yenile
                </button>
            </header>

            {loading ? (
                <div className="flex justify-center py-20">
                    <Loader2 className="h-8 w-8 animate-spin text-[#D4AF37]" />
                </div>
            ) : null}

            {data?.ozet ? (
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
                    <div className="rounded-2xl border border-white/10 bg-[#0a1018]/80 p-4">
                        <p className="text-[10px] uppercase text-slate-500">Toplam kayıt</p>
                        <p className="text-2xl font-bold text-white mt-1">{data.ozet.toplam || 0}</p>
                    </div>
                    <div className="rounded-2xl border border-emerald-500/20 bg-emerald-500/5 p-4">
                        <p className="text-[10px] uppercase text-slate-500">Ort. çarpan</p>
                        <p className="text-2xl font-bold text-emerald-300 mt-1">
                            {(data.ozet.ort_carpan || 1).toFixed(3)}
                        </p>
                    </div>
                    <div className="rounded-2xl border border-violet-500/20 p-4">
                        <p className="text-[10px] uppercase text-slate-500">Marka çeşidi</p>
                        <p className="text-2xl font-bold text-violet-200 mt-1">
                            {data.marka_carpanlari?.length || 0}
                        </p>
                    </div>
                    <Link
                        to="/yeni/deger-kaybi-gelismis"
                        className="rounded-2xl border border-[#D4AF37]/30 bg-[#D4AF37]/5 p-4 hover:bg-[#D4AF37]/10 transition flex flex-col justify-center"
                    >
                        <Sliders className="h-5 w-5 text-[#D4AF37] mb-2" />
                        <span className="text-sm font-semibold text-[#F3E5AB]">Gelişmiş DK hesap →</span>
                    </Link>
                </div>
            ) : null}

            {data?.marka_carpanlari?.length ? (
                <section>
                    <h2 className="text-lg font-semibold text-white mb-3 flex items-center gap-2">
                        <Gauge className="h-5 w-5 text-[#D4AF37]" />
                        Marka / model çarpanları
                    </h2>
                    <div className="rounded-2xl border border-white/[0.08] overflow-x-auto">
                        <table className="w-full text-sm min-w-[640px]">
                            <thead className="bg-white/[0.03] text-[10px] uppercase text-slate-500">
                                <tr>
                                    <th className="text-left px-4 py-3">Marka</th>
                                    <th className="text-left px-4 py-3">Model</th>
                                    <th className="text-right px-4 py-3">Çarpan</th>
                                    <th className="text-right px-4 py-3">Canlı</th>
                                    <th className="text-right px-4 py-3">Kayıt</th>
                                    <th className="text-right px-4 py-3">Ort. hesap</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-white/[0.04]">
                                {data.marka_carpanlari.map((row, i) => (
                                    <tr key={i} className="hover:bg-white/[0.02]">
                                        <td className="px-4 py-2.5 text-slate-200 capitalize">{row.marka}</td>
                                        <td className="px-4 py-2.5 text-slate-400">{row.model || "—"}</td>
                                        <td className="px-4 py-2.5 text-right tabular-nums text-[#F3E5AB] font-semibold">
                                            {row.ogrenme_carpani?.toFixed(3)}
                                        </td>
                                        <td className="px-4 py-2.5 text-right tabular-nums text-emerald-400">
                                            {row.canli_carpan?.toFixed(3)}
                                        </td>
                                        <td className="px-4 py-2.5 text-right text-slate-500">{row.kayit_sayisi}</td>
                                        <td className="px-4 py-2.5 text-right tabular-nums text-slate-500">
                                            ₺{Number(row.ort_hesap || 0).toLocaleString("tr-TR")}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </section>
            ) : null}
        </div>
    );
}
